import React from "react";
import { View } from "react-native";
import { Checkbox, Text } from "react-native-paper";
import { ChecklistValue } from "./checklistTypes";

type ChecklistDetailsDisplayProps = {
  value: ChecklistValue[];
  label: string;
  outlineColor?: string;
  onToggleItem: (checklistId: string, itemId: string) => void;
};

export const ChecklistDetailsDisplay = ({
  value,
  label,
  outlineColor,
  onToggleItem,
}: ChecklistDetailsDisplayProps) => {
  return (
    <View style={{ marginVertical: 8 }}>
      <Text variant="titleMedium" style={{ marginBottom: 8 }}>
        {label}
      </Text>
      {value.map((checklist) => (
        <View
          key={checklist.id}
          style={{
            marginBottom: 16,
            borderWidth: 1,
            borderColor: outlineColor,
            borderRadius: 8,
            padding: 12,
          }}
        >
          <Text
            variant="titleSmall"
            style={{ fontWeight: "bold", marginBottom: 8 }}
          >
            {checklist.title}
          </Text>
          {checklist.items?.map((item) => (
            <View
              key={item.id}
              style={{
                flexDirection: "row",
                alignItems: "center",
                marginBottom: 4,
              }}
            >
              <Checkbox.Item
                label={item.text}
                status={item.checked ? "checked" : "unchecked"}
                onPress={() => onToggleItem(checklist.id, item.id)}
                style={{ paddingLeft: 0, flex: 1 }}
                labelStyle={
                  item.checked
                    ? {
                        textDecorationLine: "line-through",
                        opacity: 0.6,
                      }
                    : undefined
                }
                position="leading"
              />
            </View>
          ))}
        </View>
      ))}
    </View>
  );
};
